module.exports = __webpack_public_path__ + "img/9788960172364.744e4c0f.jpg";